import { render } from "./RevenueCollectionTables.vue?vue&type=template&id=09bb9466"
import script from "./RevenueCollectionTables.vue?vue&type=script&lang=js"
export * from "./RevenueCollectionTables.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__